export const useShouldCheckCapabilities = () => {
  if (process.server) {
    return process.env.CHECK_CAPABILITIES === "true";
  }

  return useRuntimeConfig().public.checkCapabilitiesEnabled == "true";
};
